import { NgModule } from '@angular/core';
//import { BourqueRailtracDataComponent } from './bourque-railtrac-data.component';

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
})
export class BourqueRailtracDataModule {}
